export default {
    'export': 'تصدير',
    'export-as-excel': 'تصدير إكسل',
    'print-the-final-accounts': 'طباعة الحسابات الختامية',
    'unlock-accounts': 'إلغاء إقفال الحسابات',
    'lock-accounts': 'إقفال الحسابات',

    account: {
        operations: 'تشغيل',
        trade: 'مُتاجرة',
        'gains-and-losses': 'أرباح وخسائر',
        budget: 'ميزانية',
    },

    'unlock-current-financial-file-accounts': 'إلغاء إقفال حسابات الملف المالي',
    'are-you-sure-you-want-to-unlock-accounts': 'هل أنت متأكد من إلغاء إقفال الحسابات؟',

    'lock-financial-file-accounts': 'إقفال حسابات الملف المالي',

    'operations-account-balance': 'رصيد حساب تشغيل:',
    'trade-account-balance': 'رصيد حساب مُتاجرة:',
    'gains-and-losses-account-balance': 'رصيد حساب أرباح وخسائر:',
    'budget-account-balance': 'رصيد حساب ميزانية:',


    'lock': 'إقفال',
    'next': 'التالي',
    'previous': 'السابق',
    'cancel': 'إلغاء',
    'lock-dialog': {
        'checking-all-bonds-are-posted': 'جميع السندات مُرّحلة',
        'checking-all-invoices-are-posted': 'جميع الفواتير مرحلة',
        'checking-all-material-journals-are-posted': 'جميع يوميات المواد مرحلة',
        'checking-all-manufacturing-bonds-are-posted': 'جميع سندات التصنيع مرحلة',
        'checking-no-negative-values-for-materials': 'ما من مواد بأرصدة سالبة',

        'radio-select': 'تحديد',
        'radio-create': 'إنشاء',

        'stepper-validate': 'تحقق',
        'stepper-lock-accounts': 'حسابات الإقفال',
        'stepper-lock': 'إقفال',

        'the-profit-and-loss-account': 'حساب مدور الأرباح والخسائر',
        'the-materials-end-of-term-account': 'حساب بضاعة آخر المدة',
        'it-is-set-in-financial-file-accounts': 'تم تعيينه من صفحة حسابات الملف المالي',

        'account': 'الحساب',
        'new-account-parent': 'الحساب الرئيسي',
        'new-account-name': 'اسم الحساب',

        'account-create-note': '*ملاحظة: الحساب الذي سيُنشأ سيكون نوعه فرعي، ومختوماً بالميزانية',

        details: `
        <span class="primary--text" style="font-size: 1rem">عند إفقال الملف المالي سيتم ما يلي:</span> <br>
        -   إنشاء حسابات (بضاعة آخر المدة - مدور الأرباح والخسائر) مختومة بالميزانية (في حال عدم وجودها).<br>
        -   إنشاء سند إقفال محاسبي يضم:<br>
            • قيود إغلاق لجميع الحسابات المختومة في (التشغيل، المتاجرة، الأرباح والخسائر) بطبيعة معاكسة لرصيد كل منها (مدين | دائن).<br>
            • قيد مدين لحساب بضاعة آخر المدة بقيمة جرد مواد المستودع.<br>
            • قيد مدين أو دائن لحساب مدور الأرباح والخسائر برصيد الأرباح والخسائر.<br>
        -   سيصبح الملف المالي الحالي مقفل من التعديل، ويحق فقط لمدير النظام إلغاء الإقفال.
        `
    },

    'sorry-you-can-not-close-the-financial-file-because-of-the-unposted-bonds-with-the-numbers' : 'عذراً ، لايمكنك إقفال الملف المالي لوجود سندات غير مُرحّلة ذات الأرقام:',

    'rerotate-financial-file': 'إعادة تدوير الملف المالي',
    'do-you-want-to-rerotate-financial-file': 'تم تدوير هذا الملف المالي إلى الملف المالي: "{financialFile}". في حال كانت عملية التدوير السابقة لم تنتهي سيتم استكمال التدوير وإلا فسيتم التدوير مرة أخرى. يمكنك فرض إعادة التدوير وقتما تريد. هل تريد المتابعة؟',

    'rotate': 'تدوير',
    're-rotate': 'إعادة تدوير',
    'resume': 'استئناف',
    'rotate-dialog': {
        'stepper-validate': 'تحقق',
        'stepper-financial-file': 'إنشاء ملف مالي',
        'stepper-move-trees': 'نقل الحسابات والمواد',
        'stepper-rotate': 'التدوير',
        'stepper-rotate-steps': 'المراحل',

        'financial-file-is-locked': 'الملف المالي مقفل ... تستطيع استكمال التدوير',
        'financial-file-is-not-locked': 'الملف المالي غير مقفل',

        'rotate-financial-file': 'تدوير الملف المالي',
        'new-financial-file-name': 'اسم الملف المالي الجديد',
        'fiscal-year-name': 'اسم السنة المالية',
        'start-fiscal-year': 'بداية السنة المالية',
        'end-fiscal-year': 'نهاية السنة المالية',
        'move-accounts-tree': 'نقل الحسابات',

        'first-term-account': {
            text: 'حساب بضاعة أول المدة',
            'account-parent': 'الحساب الرئيسي',
            'account-name': 'اسم الحساب',
            'account-no': 'رقم حساب بضاعة أول المدة',
        },

        'move-materials-trees': 'نقل المواد',
        'same-parent-no': 'رقم الحساب مستخدم من قبل',

        'the-financial-file-is-ready-to-rotate': 'الملف المالي جهاز ليتم تدويره ... انقر "تدوير" للمتابعة',

        details: `
        <span class="primary--text" style="font-size: 1rem">عند تدوير الملف المالي سيتم ما يلي:</span> <br>
        -	 إنشاء ملف عام مالي جديد، بنفس العملة الافتراضية للملف السابق.<br>
        - 	إضافة صلاحيات وصول على الملف الجديد مُطابقة للملف السابق (بالإمكان تعديل الصلاحيات من قِبل المدير).<br>
        -   نقل جميع الحسابات والكشوف المُخصصة من الملف السابق إلى الملف الجديد.<br>
        -	 إنشاء السند الافتتاحي بأرصدة الميزانية من الملف السابق، وافتتاح حساب بضاعة أول المدة.<br>
        -	 نقل جميع المستودعات والمواد.<br>
        -	 تثمين الكميات المتوفرة من المواد في المستودعات (جرد المستودعات):<br>
            • سيتم اعتماد أسعار جرد المواد التي سبق أن تم تعيينها (من قسم جرد مواد) وفي حال وجود مواد بأسعار جرد غير محددة سيتم اعتماد آخر سعر شراء لها.<br>
        -	 إنشاء سند يومية مواد افتتاحي بقيود المواد ذات الأرصدة من الملف السابق        
        `,

        steps: {
            'create-new-financial-file': 'إنشاء ملف مالي جديد',
            'move-accounts-tree': 'نقل شجرة الحسابات',
            'move-custom-statements': 'نقل الكشوف المخصصة',
            'move-item-trees': 'نقل شجرة المواد',
            'create-opening-accounting-bond': 'إنشاء سند افتتاحي',
            'create-opening-items-journal': 'إنشاء يومية مواد افتتاحية',
            'init-access-permissions': 'تهيئة الصلاحيات',
        },
        'in-progress': 'قيد العمل',

        'wait-please': 'سيستغرق الأمر بضع دقائق، شكراً لصبرك',
    }
}